import styled from 'styled-components';
// import { Card, Col } from 'react-bootstrap';
import { TextInput, Button } from 'carbon-components-react';
const ArrayInput = ({value, setValue}) => {
  return(
    <div>
    { value?.length > 0 && value?.map((element, index) => {
      return(
        <InputContainer>
        <TextInput
          value={element}
          onChange={e => {
            let newState = [...value]
            newState[index] = e.target.value
            setValue(newState)
          }}
        />
        <DeleteIconContainer>
          <i 
            className="fal fa-trash-alt" 
            style={{color: 'red'}} 
            onClick={() => {
              let newState = [...value]
              newState.splice(index, 1)
              setValue(newState)
            }}
            />
        </DeleteIconContainer>
      </InputContainer>
      )
    })}
    <Button
      kind="primary"
      onClick={() => {
        if(value){
          setValue(
            [...value, ""]
          )
        }
        else{
          setValue([""])
        }
    }}
    >+ Add</Button>
    </div>
  )
}

export default ArrayInput;

const InputContainer = styled.div`
  margin-bottom: 12px;
  width: 250px;
  display: flex;
`

const DeleteIconContainer = styled.div`
  padding-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`